import React, { useState } from 'react';
import _get from 'lodash/get';
import Family from './Family';

const families = [
    {
        group: {
            groupId: 1,
        },
        descendantRoles: {
            parentList: [
                {
                    pawn: {
                        pawnId: 1,
                    },
                    role: {
                        handle: 'parent',
                    },
                    user: {
                        firstName: 'Deb',
                        lastName: 'Childress',
                        fullName: 'Deb Childress',
                        username: 'deb@childress.com',
                        lastLoginDate: '01/02/2026',
                    },
                },
                {
                    pawn: {
                        pawnId: 2,
                    },
                    role: {
                        handle: 'parent',
                    },
                    user: {
                        firstName: 'Larry',
                        lastName: 'Childress',
                        fullName: 'Larry Childress',
                        username: 'deb@childress.com',
                        lastLoginDate: '12/30/2025',
                    },
                },
            ],
            childList: [
                {
                    pawn: {
                        pawnId: 3,
                    },
                    role: {
                        handle: 'child',
                    },
                    user: {
                        firstName: 'Lil Jimmy',
                        lastName: 'Childress',
                        fullName: 'Lil Jimmy Childress',
                        username: 'jimmy@childress.com',
                        lastLoginDate: '01/17/2026',
                    },
                },
            ],
        },
    },

    {
        group: {
            groupId: 2,
        },
        descendantRoles: {
            parentList: [
                {
                    pawn: {
                        pawnId: 4,
                    },
                    role: {
                        handle: 'parent',
                    },
                    user: {
                        firstName: 'Kim',
                        lastName: 'Huegel',
                        fullName: 'Kim Huegel',
                        username: 'kim@huegel.com',
                        lastLoginDate: '01/02/2026',
                    },
                },
            ],
            childList: [
                {
                    pawn: {
                        pawnId: 4,
                    },
                    role: {
                        handle: 'child',
                    },
                    user: {
                        firstName: 'Morgan',
                        lastName: 'Huegel',
                        fullName: 'Morgan Huegel',
                        username: 'morgan@huegel.com',
                        lastLoginDate: '01/01/2026',
                    },
                },
            ],
        },
    },

    {
        group: {
            groupId: 3,
        },
        descendantRoles: {
            parentList: [
                {
                    pawn: {
                        pawnId: 6,
                    },
                    role: {
                        handle: 'parent',
                    },
                    user: {
                        firstName: 'Betsy',
                        lastName: 'Messina',
                        fullName: 'Betsy Messina',
                        username: 'betsy@messina.com',
                        lastLoginDate: '11/02/2025',
                    },
                },
                {
                    pawn: {
                        pawnId: 7,
                    },
                    role: {
                        handle: 'parent',
                    },
                    user: {
                        firstName: 'John',
                        lastName: 'Messina',
                        fullName: 'John Messina',
                        username: 'john@messina.com',
                        lastLoginDate: '11/08/2025',
                    },
                },
            ],
            childList: [
                {
                    pawn: {
                        pawnId: 8,
                    },
                    role: {
                        handle: 'child',
                    },
                    user: {
                        firstName: 'Suzanne',
                        lastName: 'Messina',
                        fullName: 'Suzanne Messina',
                        username: 'suzanne@messina.com',
                        lastLoginDate: '10/06/2025',
                    },
                },
                {
                    pawn: {
                        pawnId: 9,
                    },
                    role: {
                        handle: 'child',
                    },
                    user: {
                        firstName: 'Juan',
                        lastName: 'Messina',
                        fullName: 'Juan Messina',
                        username: 'juan@messina.com',
                        lastLoginDate: '10/08/2025',
                    },
                },
            ],
        },
    },
];

function CoachDashboard() {
    const [pinnedFamilies, setPinnedFamilies] = useState([3]);

    function getMainParentName(family) {
        return _get(family, 'descendantRoles.parentList.0.user.fullName');
    }

    function getIsPinned(family) {
        return pinnedFamilies.includes(family.group.groupId);
    }

    function togglePinned(family) {
        const familyGroupId = _get(family, 'group.groupId');

        if (pinnedFamilies.includes(familyGroupId)) {
            setPinnedFamilies(prev => prev.filter(id => id !== familyGroupId));
        } else {
            setPinnedFamilies(prev => [...prev, familyGroupId]);
        }
    }

    return (
        <div>
            {families
                .sort((a, b) => {
                    const isAPinned = getIsPinned(a);
                    const isBPinned = getIsPinned(b);
                    if (isAPinned === isBPinned) {
                        return getMainParentName(a).localeCompare(getMainParentName(b));
                    }

                    if (isAPinned) {
                        return -1;
                    }

                    return 1;
                })
                .map((family, i) => (
                    <Family
                        key={_get(family, 'group.groupId', 'fam' + i)}
                        family={family}
                        getMainParentName={getMainParentName}
                        isPinned={getIsPinned(family)}
                        togglePinned={togglePinned}
                    />
                ))}
        </div>
    );
}

export default CoachDashboard;
